// @flow

import React, { type Node } from 'react';
import styled, { css } from 'styled-components';
import { translate } from '@tectonics/translate';
import { useDevice } from '../../../template/device';
import ebanxLogoSrc from '../../../../shopify-embedded/images/ebanx-logo-full.svg';

export function Footer(): Node {
  const device = useDevice();

  return (
    <FooterWrapper desktop={device === 'desktop'}>
      <ContentWrapper desktop={device === 'desktop'}>
        <FooterMessage />
      </ContentWrapper>
    </FooterWrapper>
  );
}

function FooterMessage(): Node {
  const footerImageSrc = ebanxLogoSrc;
  const footerImageAltText = 'EBANX';

  return (
    <>
      <p>{translate('shopify.footerMessagePaymentVia')}</p>
      <FooterImage src={footerImageSrc} alt={footerImageAltText} />
    </>
  );
}

const FooterWrapper = styled.div`
  font-family: ${props => props.theme.fontFamily.sansSerif};
  font-size: 0.86rem;
  color: ${props => props.theme.colors.gray[2]};
  display:flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  ${props => props.desktop && css`
    margin-top: 5px;
    display: block;
    justify-content: center;
    padding-left: 4vw;
  `}
`;

const FooterImage = styled.img`
  height: 100%;
  padding-left: 3px;
  max-width: 74px;
`;

const ContentWrapper = styled.div`
  border-top: 0.5px solid ${props => props.theme.colors.gray[1]};
  padding: 20px 0;
  display:flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 0 15px;
  ${props => props.desktop && css`
    width: 350px;
    margin: 0;
  `}
`;
